import { Seo } from '../components/seo';

function HomePage() {
  return (
    <Seo title="Dashboard" />
  );
}

export default HomePage;
